/**
 * HomeLoadingState - Skeleton loading state for the home screen
 *
 * Shows 3-4 skeleton cards with shimmer animation while mission data
 * is being loaded/analyzed. Optionally displays a progress percentage.
 *
 * @see docs/architecture/OwnYou_architecture_v13.md Section 4.5
 */

import { cn } from '@ownyou/ui-design-system';
import { Skeleton } from '@ownyou/ui-components';

export interface HomeLoadingStateProps {
  /** Loading progress from 0 to 100; omitted if unknown */
  progress?: number;
  className?: string;
}

export function HomeLoadingState({ progress, className }: HomeLoadingStateProps) {
  return (
    <div
      data-testid="home-loading-state"
      className={cn('flex flex-col gap-4', className)}
    >
      {/* Status text */}
      <p className="text-body text-neutral-500 text-center">
        Analyzing your data...
        {progress != null && (
          <span className="font-medium text-neutral-700 ml-1">
            {Math.round(progress)}%
          </span>
        )}
      </p>

      {/* Skeleton cards */}
      <Skeleton variant="card" />
      <Skeleton variant="card" />
      <Skeleton variant="card" />
      <Skeleton variant="card" />
    </div>
  );
}
